import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { OptionalEmailString } from '../email';

export const ManagePointOfContactSpecialistRow = (teamSpecialistKeys: string[]) => {
  // Handle empty array case - z.enum requires at least one value
  const enumValues = teamSpecialistKeys.length > 0 ? teamSpecialistKeys : ['No team specialist keys available'];

  return z.object({
    loanId: LosId,
    teamSpecialistKey: z
      .enum(enumValues as [string, ...string[]]) // enum requires at least one value
      .describe('Key associated with a team specialist'),
    pointOfContact: OptionalEmailString.describe(
      'Email address of internal user who is the specialist point of contact. Leaving this field blank removes the point of contact',
    ), // lender user email address. undefined value removes the POC
  });
};
export type ManagePointOfContactSpecialistRow = z.infer<ReturnType<typeof ManagePointOfContactSpecialistRow>>;

export const MANAGE_POINT_OF_CONTACT_SPECIALIST_ROW_REQUIRED_FIELDS = ['loanId', 'teamSpecialistKey'];
